import { render } from "./SelectionStep.vue?vue&type=template&id=cd80fe96&scoped=true"
import script from "./SelectionStep.vue?vue&type=script&lang=js"
export * from "./SelectionStep.vue?vue&type=script&lang=js"

import "./SelectionStep.vue?vue&type=style&index=0&id=cd80fe96&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/doineedavpn.com/doineedavpn.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd80fe96"]])

export default __exports__